import log from "./logevent";
import { isPlainObject, isString, withProperties } from "../utils";
import logErrors from "./logerrors";

let isFirstPaymentOption = true;

function __log__(action, object, comment, data) {
  return log({ action, object, comment, data });
}

function __string__(value) {
  return isString(value) ? value : String();
}

function __lower__(value) {
  return __string__(value).toLowerCase();
}

function __label__(value) {
  return __string__(value)
    .replace(/(.*?)(\b[A-Z]+\b)(.*?)/g, (_, $1, $2, $3) => (
      `${__lower__($1)}${$2}${__lower__($3)}`
    ));
}

function initializedModal() {
  try {
    const $data = isPlainObject(this) ? this : {};
    const { init_url, ip, txref: ref, currency, amount } = $data;
    const data = { ref, amount, currency, ip };

    const comment = `Initiated Checkout${
      init_url ? ` from ${decodeURIComponent(init_url)}` : ""
    }`;

    return __log__('loaded', 'modal', comment, data);
  } catch (e) {
    return __log__('loaded', 'modal', 'Initiated Checkout');
  }
}

function closeModal(postSuccessfulPayment = false) {
  let text = postSuccessfulPayment === true ? 'Closed modal after successful payment' : 'Closed modal'
  return __log__('closed', 'modal', text);
}

function switchedPaymentOption(method) {
  if (isFirstPaymentOption === true) {
    isFirstPaymentOption = false;
    return __log__('launched', 'modal', `Launched ${method} as initial payment option`);
  }

  return __log__('switched', 'modal', `Switched to ${method} option`);
}

function transactionSuccessful() {
  return __log__('completion', 'TRANSACTION', 'Transaction Completed!');
}

function transactionFailed() {
  return __log__('failure', 'TRANSACTION', 'Transaction Failed!');
}

function transactionTimeout() {
  return __log__('timeout', 'TRANSACTION', 'Transaction Session Timeout!');
}

function transactionPending() {
  return __log__('pending', 'TRANSACTION', 'Transaction Pending!');
}

function paypalPendingMerchantAction() {
  return __log__('charge', 'PAYPAL', 'Charge processing completed: Pending merchant action.');
}

function startedEnteringInput(label) {
  return __log__('typing', label, `Entering ${__label__(label)}`);
}

function stoppedEnteringInput(label) {
  return __log__('typing', label, `Stopped entering ${__label__(label)}`);
}

function selectedInputOption(label, value) {
  return __log__('selected', label, `Selected ${value}`);
}

function redirectingToMerchant(data) {
  return __log__('redirect', 'REDIRECT_URL', `Redirecting to merchant`, data)
}

function eNairaOptionSelected(value) {
  return __log__('eNaira option selected', 'modal', `Selected eNaira ${value}`);
}

function startEnairaTokenValidation() {
  return __log__('eNaira token validation', 'modal', 'Starting eNaira token validation');
}

function customerOpenedRedirectURL(label, value) {
  // Payment method should be sent as label and value here:
  // e.g "eNaira redirect URL opened, 'mpdal', Customer opened eNaira Direct Wallet Debit verification page"
  return __log__(`${label} redirect URL opened`, 'modal', `Customer opened ${value} verification page`)
}

function customerAttemptingCharge(label) {
  return __log__(`${label} charge`, 'modal', `Attempting ${label} charge`)
}

function customerReturnedFromVerificationPage() {
  return __log__('verification page', 'modal', 'Customer returned returned from verification page')
}

function chargeRequestStatus(value) {
  return __log__('charge request', 'modal', `Charge request ${value}`)
}

function changedLanguage(value) {
  return __log__('locale change', 'modal', `Changed language to ${value}`)
}

function logUntranslatedError(value) {
  return logErrors(value);
}

function beneficiaryExtractionFailed(value) {
  return __log__('beneficiary extraction', 'modal', `Could not read a beneficiary from transfer note: ${__string__(value)}`)
}

export default withProperties(Object.create(null), {
  closeModal,
  initializedModal,
  transactionSuccessful,
  transactionFailed,
  transactionTimeout,
  paypalPendingMerchantAction,
  redirectingToMerchant,
  selectedOption: selectedInputOption,
  startedInput: startedEnteringInput,
  stoppedInput: stoppedEnteringInput,
  switchedMethod: switchedPaymentOption,
  eNairaOptionSelected,
  startEnairaTokenValidation,
  customerOpenedRedirectURL,
  customerAttemptingCharge,
  customerReturnedFromVerificationPage,
  chargeRequestStatus,
  changedLanguage,
  logUntranslatedError,
  transactionPending,
  beneficiaryExtractionFailed
});
